'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.days;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/number/days.js
// module id = 156
// module chunks = 0